import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-be6a1b08"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "palcode-success-popup rwd-popup"
};
const _hoisted_2 = {
  key: 0,
  class: "popup-main"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ico-close-o"
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popup-title"
}, "温馨提示", -1));
const _hoisted_6 = {
  class: "popup-body"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "推荐好友任务审核中，", -1));
const _hoisted_8 = {
  class: "text-brand-red"
};
const _hoisted_9 = {
  class: "popup-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "popup-overlay pointer",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.close && $setup.close(...args))
  }), $setup.state.isGetData ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
    class: "popup-close",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.close && $setup.close(...args))
  }, _hoisted_4), _hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", null, [_createTextVNode("核实无误后，"), _createElementVNode("strong", _hoisted_8, _toDisplayString($setup.palcodeBonus.recommendedBy) + "福米", 1), _createTextVNode("将自动添加至账号")])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_button, {
    round: "",
    block: "",
    class: "btn-brand btn-brand-red",
    onClick: $setup.linkToTaskList
  }, {
    default: _withCtx(() => [_createTextVNode("看看其他任务")]),
    _: 1
  }, 8, ["onClick"])])])) : _createCommentVNode("", true)]);
}